import React, { useRef, useState, useEffect } from "react"
import ReactFullpage from "@fullpage/react-fullpage"
import tw, { styled } from "twin.macro"
import { Helmet } from "react-helmet"

const pluginWrapper = () => {
  require('../utils/fullpage.fadingEffect.min')
};

// Utils
import { SlideInfo } from "../slides"

// Components
import BottomBar from "./bottomBar"
import FeaturesSlide from "../slides/featuresSlide"
import HeaderVideo from "./headerVideo"
import TrainingSlide from "../slides/trainingSlide"
import LogoSlide from "../slides/logoSlide"
import SEO from "../components/seo"
import HomeGrownSlide from "../slides/homeGrownSlide"
import TopBar from "./topBar"
import TrainNowSlide from "../slides/trainNowSlide"
import SubsidiesSlide from "../slides/subsidiesSlide"

const metaDescription = "MITO Automotive Apprentice"

const slides: SlideInfo[] = [
  {
    component: LogoSlide,
    anchor: "#intro",
    seo: { title: "Your smartest investment" },
  },
  {
    component: FeaturesSlide,
    anchor: "feature_learning",
    seo: { title: "Super-fast Learning Capacity" },
    slideProps: { featureIndex: 0}
  },
  {
    component: FeaturesSlide,
    anchor: "feature_design",
    seo: { title: "Ultra-modern Design" },
    slideProps: { featureIndex: 1}
  },
  {
    component: FeaturesSlide,
    anchor: "feature_skillsets",
    seo: { title: "Customisable Skillsets" },
    slideProps: { featureIndex: 2}
  },
  {
    component: FeaturesSlide,
    anchor: "feature_energy",
    seo: { title: "Superior Energy Reserves" },
    slideProps: { featureIndex: 3 }
  },
  {
    component: SubsidiesSlide,
    anchor: "#subsidies",
    seo: { title: "Subsidies available now" },
  },
  {
    component: HomeGrownSlide,
    anchor: "#homegrown",
    seo: { title: "Home-grown talent" },
  },
  {
    component: TrainingSlide,
    anchor: "#training",
    seo: { title: "Gold standard training" },
  },
  {
    component: TrainNowSlide,
    anchor: "#trainnow",
    seo: { title: "Got someone to train?" },
  }
]

const SlidesContainer: React.FC = () => {
  // Keep isClient == true when it's the client rendering and not the server
  const [isClient, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
    // Move to the slide in the hash.. for some reason this isn't working
    // using the built in support for slide links...
    const slide = window.location.hash
    if (slide) {
      reactFullpage.current?.fullpageApi.moveTo(slide)
    }
  }, [])

  const [slideIndex, setSlideIndex] = useState<number>(0)
  const [hideEnrolButton, setHideEnrolButton] = useState<boolean>(false)
  const [showTitle, setShowTitleText] = useState<boolean>(false)
  const reactFullpage: React.RefObject<ReactFullpage> = useRef<ReactFullpage>(
    null
  )

  return (
    <SlidesWrapper>
      <SEO {...slides[slideIndex].seo} description={metaDescription} />
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/imk8sgg.css" />
      </Helmet>

      <TopBar
        hideEnrolButton={hideEnrolButton}
        showTitle={showTitle}
      enrolButtonClicked={() => {
          reactFullpage.current?.fullpageApi.moveTo(slides.length)
        }}
      />

      <HeaderVideo hide={slideIndex != 0} overlay={slideIndex != 0} />

      <ReactFullpage
        pluginWrapper = {pluginWrapper}
        ref={reactFullpage}
        scrollingSpeed={1000} /* Options here */
        licenseKey="1B8D94EF-53504EE2-97F80D91-B1AE13D3"
        scrollOverflow
        autoScrolling
        recordHistory
        fadingEffect
        fadingEffectKey="bWl0by5vcmcubnpfV1VsWm1Ga2FXNW5SV1ptWldOMGZTbA=="
        anchors={slides.map(s => s.anchor)}
        // responsiveHeight={RESPONSIVE_HEIGHT}
        onLeave={(origin, destination, direction) => {
          setSlideIndex(destination.index);
          setHideEnrolButton(destination.index == slides.length-1);
          setShowTitleText(destination.index > 0);
        }}
        render={({ fullpageApi }) => {
          return (
            <div>
              <ReactFullpage.Wrapper>
                {slides.map((slide, idx) => (
                  <slide.component
                    key={idx}
                    isClient={isClient}
                    nextButtonClicked={() => fullpageApi.moveSectionDown()}
                    slideVisible={slideIndex == idx}
                    {...slide.slideProps}
                  />
                ))}
              </ReactFullpage.Wrapper>
            </div>
          )
        }}
      />

      <BottomBar
        hideEnrolButton={hideEnrolButton}
        enrolButtonClicked={() => {
          reactFullpage.current?.fullpageApi.moveTo(slides.length)
        }}
      />
    </SlidesWrapper>
  )
}

const SlidesWrapper = styled.div`
  ${tw`text-white min-h-screen`}
`
export default SlidesContainer
